import { z } from 'zod'

/**
 * The font on an organization's signer pages and signer email: `inter`
 * (PixelSign's) or `system`, each device's own interface font, closer to a
 * host app that uses it.
 */
export const FONT_FAMILIES = ['inter', 'system'] as const

export const fontFamilySchema = z.enum(FONT_FAMILIES)

export type FontFamily = z.infer<typeof fontFamilySchema>

/** A stored value as a font family, PixelSign's for anything unknown. */
export const storedFontFamilySchema = fontFamilySchema.catch('inter')
